
<button
  :class="constructedClass"
  class="ui-button ui-button--loading text-sm text-black focus:outline-none"
  :disabled="!active"
  v-on="$listeners"
>
  <slot></slot>
</button>
